import { render, staticRenderFns } from "./dish-table.vue?vue&type=template&id=63c1fb1b&"
import script from "./dish-table.vue?vue&type=script&lang=js&"
export * from "./dish-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports